import {createFileRoute} from "@tanstack/react-router";
import {useTranslation} from "../../../../utils/helpers";
import React, {useMemo} from "react";
import {Columns} from "../../../../components/generic/columns";
import {CwgSearchResult} from "../../../../components/cwg/cwgSearchResult";
import {CwgSearchForm} from "../../../../components/cwg/cwgSearchForm";
import {XwgQueryResponse} from "../../../../models/xwg";
import {SearchHint} from "../../../../components/cwg/searchHint";
import {TagCategory} from "../../../../models/tag";
import {UserSearch} from "../../../../models/user";
import {UserSearchForm} from "../../../../components/users/searchForm";
import {XwgFilter} from "../../../../models/xwgSearchQuery";
import {ROUTES} from "../../../../constants";

export const Route = createFileRoute('/_site/cwg/search/')({
    component: SearchHint
});

export function CwgSearch({tagCategories,  result, offset, limit, onOffsetChange, filter = {}}: {
    tagCategories: TagCategory[],
    offset?: number,
    limit?: number,
    filter?: XwgFilter,
    result?: XwgQueryResponse | null,
    onOffsetChange?: (newOffset: number) => void
}) {
    const {t: tb} = useTranslation("browse");
    const {t: ts} = useTranslation("search");

    const navigate = Route.useNavigate();

    const searchForm = useMemo(() => {
        return <CwgSearchForm
            tagCategories={tagCategories}
            filter={filter}
            onSearch={async ({names, ...filter}: XwgFilter) => {
                if (!(names?.[0])) {
                    return;
                }

                await navigate({
                    to: ROUTES.XWG_SEARCH_WITH_QUERY,
                    params: {
                        query: names?.[0] as string
                    },
                    search: {
                        offset: 0,
                        limit: limit ?? 100,
                        filter: filter
                    }
                });
            }}
        />
    }, [tagCategories, filter]);

    return (
        <Columns>
            <>
                <h3>{tb("Search the catalogue")}</h3>
                {searchForm}

                <h3>{ts("User search")}</h3>
                <UserSearchForm
                    onSearch={async (search: UserSearch) => {
                        await navigate({
                            to: ROUTES.USER_SEARCH_WITH_QUERY,
                            params: {
                                username: search.username
                            }
                        })
                    }}
                />
            </>
            {result
                ? <>
                    <h3>{ts("Search result")}</h3>
                    <CwgSearchResult
                        search={result}
                        offset={offset}
                        limit={limit}
                        onOffsetChange={onOffsetChange}
                    />
                </>
                : <SearchHint/>
            }
        </Columns>
    );
}
